<template>
  <div class="info-menubar">
    <div
      v-for="index in lang.infoSlides.length"
      :key="index"
      :class="{tab: true, selected: activeSlide == index}"
      @click="changeSlide(index)">
      <div
        class="pic"
        :style="`background-image: url(/assets/images/info-slides/info-slides-${index}.jpg), url(/assets/images/info-slides/info-slides-small-${index}.jpg);`" />
      <h3 class="label" v-html="lang.infoSlides[index - 1].title" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "InfoMenubar",
  components: {},
  methods: {
    ...mapActions("infoSlides", ["changeSlide"])
  },
  computed: {
    ...mapGetters("languages", ["lang"]),
    ...mapGetters("infoSlides", ["activeSlide"])
  }
};
</script>

<style lang="scss" scoped>
.info-menubar {
  width: 100%;
  text-align: center;
  .tab {
    display: inline-block;
    width: 25%;
    margin-top: $info-menubar-margin-top;
    text-align: center;
    vertical-align: top;
    cursor: pointer;
    .pic {
      display: inline-block;
      width: $info-menubar-button-size;
      height: $info-menubar-button-size;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      border: $color-primary-2 solid 1px;
      border-radius: $info-menubar-button-border-radius;
      filter: grayscale(100%);
      transition-property: all;
      transition-duration: $info-menubar-button-transition-duration;
      transition-timing-function: $info-menubar-button-transition-timing-function;
    }
    .label {
      padding: 10px 0;
    }
    &.selected {
      .pic {
        border: $info-menubar-button-border;
        filter: grayscale(0);
      }
      .label {
        color: $color-secondary-1;
      }
    }
  }
  @media only screen and (min-width: $mobile-width) {
    .tab:hover {
      .pic {
        border: $info-menubar-button-border;
        filter: grayscale(0);
      }
      .label {
        color: $color-secondary-1;
      }
    }
  }
}
</style>
